
import { GridDataService } from './grid-data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MessageHandlerService } from '../../utility/message-handler.service';

@Injectable()
export class AuditChannelListService extends GridDataService
{
  public auditTypes: Array<{ text: string; key: string; value: number }> = [
    { text: 'Channel', key: 'AUDIT-CHANNEL-TYPE-CHANNEL', value: 0 },
    { text: 'Users', key: 'AUDIT-CHANNEL-TYPE-USERS', value: 1 },
    { text: 'Groups', key: 'AUDIT-CHANNEL-TYPE-GROUPS', value: 2 },
    { text: 'Restricted Data Reasons', key: 'RESTRICTED-DATA-REASONS', value: 3 },
    { text: 'Goals', key: 'AUDIT-CHANNEL-TYPE-GOALS', value: 4 }
  ];

  constructor(http: HttpClient, translate: TranslateService, messageHandlerService: MessageHandlerService)
  {
    super(http, '/audit/channel/search', translate, messageHandlerService);
  }

  public getAuditTypeText(auditType: number): string
  {
    let text = auditType.toString();
    const revision = this.auditTypes.find(x => x.value === auditType);
    if (revision !== undefined)
    {
      text = revision.text;
    }
    return text;
  }
}
